<template>
  <el-row>
    <el-col :span="6">
      <el-cascader
        popper-class="area-tree"
        ref="areaList"
        style="width: 100%"
        placeholder="请选择行政区域"
        filterable
        :props="{ checkStrictly: true }"
        :options="areaList"
        @change="areaChange"
        v-model="interNoGetSelect.administrativeAreas"
      >
      </el-cascader>
    </el-col>
    <el-col :span="6">
      <el-select
        style="width: 100%"
        filterable
        placeholder="请选择所属行业"
        v-model="interNoGetSelect.industry"
      >
        <el-option
          v-for="item in industryList"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        ></el-option>
      </el-select>
    </el-col>
    <el-col :span="6">
      <el-select
        style="width: 100%"
        filterable
        placeholder="请选择设备类型"
        v-model="interNoGetSelect.deviceType"
      >
        <el-option
          v-for="item in gbDeviceTypeList"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        ></el-option>
      </el-select>
    </el-col>
    <el-col :span="6">
      <el-select
        style="width: 100%"
        filterable
        placeholder="请选择网络接入"
        v-model="interNoGetSelect.networkAccess"
      >
        <el-option
          v-for="item in networkAccessList"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        ></el-option>
      </el-select>
    </el-col>
  </el-row>
</template>
<script>
import { isEmpty, isEqual } from 'lodash';
import deviceApi from 'api/home/device-mangement';
import { getGbList } from '@/utils/getGbList';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    areaList: {
      default: () => []
    },
    isChannel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //   history: {
      //     deviceNoNational: '',
      //     channelNo1: '',
      //     interNoGetSelect: {
      //       administrativeAreas: [],
      //       industry: '',
      //       deviceType: '',
      //       networkAccess: ''
      //     }
      //   },
      industryList: [],
      networkAccessList: [],
      gbDeviceTypeList: [],
      interNoGetSelect: {
        administrativeAreas: [],
        industry: '',
        deviceType: '',
        networkAccess: ''
      },
      gbNo: ''
    };
  },
  created() {
    this.getGbList();
  },
  watch: {
    value: {
      deep: true,
      handler: function (newVal) {
        this.gbNo = newVal;
      }
    },
    gbNo: {
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    },
    interNoGetSelect: {
      deep: true,
      handler: function (newVal) {
        //   !isEqual(this.history.interNoGetSelect, newVal) &&
        if (this.nationNoListTypeFlag) {
          this.getNationNo();
        }
      }
    }
  },
  computed: {
    nationNoListTypeFlag() {
      const { administrativeAreas, industry, deviceType, networkAccess } = this.interNoGetSelect;
      const flag =
        !isEmpty(administrativeAreas) &&
        !isEmpty(industry) &&
        !isEmpty(deviceType) &&
        !isEmpty(networkAccess);
      return flag;
    }
  },
  methods: {
    getNationNo() {
      if (!this.nationNoListTypeFlag) {
        return;
      }
      const { administrativeAreas, industry, deviceType, networkAccess } = this.interNoGetSelect;
      const data = {
        isChannel: this.isChannel,
        networkCode: networkAccess,
        deviceTypeCode: deviceType,
        industryCode: industry,
        areaCode: administrativeAreas[administrativeAreas.length - 1]
      };
      deviceApi.getGbNo(data).then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        this.gbNo = data;
      });
    },
    reset() {
      this.gbNo = '';
      this.interNoGetSelect = {
        administrativeAreas: [],
        industry: '',
        deviceType: '',
        networkAccess: ''
      };
    },
    getGbList() {
      getGbList(this);
    },
    areaChange(val) {
      this.$nextTick(() => {
        this.$refs.areaList.dropDownVisible = false;
      });
    }
  }
};
</script>